// For modals
document.addEventListener('click', function(event) {
  const target = event.target.closest('.modal-activator')

  if (target) {
    const modal = target.parentNode.getElementsByClassName('modal')[0]
    modal.classList.add('is-active')
  }
})
document.addEventListener('click', function(event) {
  const target = event.target.closest('.modal-delete')

  if (target) {
    const modal = target.closest('.modal')
    modal.classList.remove('is-active')
  }
})
document.addEventListener('click', function(event) {
  const target = event.target.closest('.modal-background')

  if (target) {
    const modal = target.closest('.modal')
    modal.classList.remove('is-active')
  }
})
document.addEventListener('keydown', function(event) {
  if (event.key === "Escape") {
    (document.querySelectorAll('.modal') || []).forEach((modal) => {
      modal.classList.remove('is-active')
    })
  }
})
